export const companyTypes = new Map([
  [1, 'Physician'],
  [2, 'Payer']
])

export const TIME_ZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles'
]

export const CONDITIONS_TYPE = new Map([
  [
    1,
    {
      title: 'Time condition : ',
      value: 1,
      textTemplate: `If current date between {:startDate} and {:endDate}.`
    }
  ],
  [
    2,
    {
      title: 'Look back condition : ',
      value: 2,
      textTemplate: `If last {:lookBackCheckInsNumber} check-in(s) has answer(s) {:title}.`
    }
  ],
  [
    3,
    {
      title: 'Tree condition : ',
      value: 3,
      textTemplate: `If "{:parentQuestionTitle}" has answer(s) {:title}.`
    }
  ]
])

export const USER_TYPES = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'Patients',
    value: 'patient'
  },
  {
    title: 'Caregivers',
    value: 'careGiver'
  }
]

export const USER_TYPES_V5 = [
  {
    key: 'all',
    title: 'All',
    label: 'All',
    value: '',
    children: [
      {
        key: 'patient',
        title: 'Patients',
        label: 'Patients',
        value: 'patient'
      },
      {
        key: 'careGiver',
        title: 'Caregivers',
        label: 'Caregivers',
        value: 'careGiver'
      }
    ]
  }
]

export const USER_TYPES_SINGLE_SELECT_V5 = [
  {
    key: 'all',
    title: 'All',
    label: 'All',
    value: ''
  },
  {
    key: 'patient',
    title: 'Patients',
    label: 'Patients',
    value: 'patient'
  },
  {
    key: 'careGiver',
    title: 'Caregivers',
    label: 'Caregivers',
    value: 'careGiver'
  }
]

export const DEFAULT_PERMISSIONS = {
  read: false,
  write: false,
  none: false
}

export const RTM_DISEASE_TYPES = new Map([
  ['respiratory', 1],
  ['muskuloskeletal', 2]
])
